module.exports = __webpack_public_path__ + "img/malabar-spinach-350x184.fd8cb3eb.jpg";